// extracted by mini-css-extract-plugin
export default {"tabPanel":"ViewTabPanel_tabPanel__rTRNj","tabPanel--no-padding":"ViewTabPanel_tabPanel--no-padding__h+Nci","tabPanel--is-comments":"ViewTabPanel_tabPanel--is-comments__aksuu"};